import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Support technique";
const heroImage = "https://net-basis.net/Bilder/technical-support-dach-customer-service.webp";
const heroAlt = "Une main tenant un tournevis utilise une interface pour le support technique TIC sur le marché DACH.";
const heroClaimLine1 = "Service client";
const heroClaimLine2 = "avec conseil sur place !";
const benefitsTitle = "Comment vous profitez de notre expertise en __support technique__ :";
const h2Intro = "NetBasis International propose sur demande un support technique local étendu, ce qui permet à nos fabricants partenaires de garantir une haute disponibilité du service client technique sur place. Ainsi, les clients bénéficient immédiatement et pleinement de la valeur et de l'utilité des produits et solutions que nous représentons.";
const p1Text = "Notre service hautement spécialisé aide les clients et partenaires à déployer et utiliser les produits et solutions rapidement et facilement, ainsi qu'à résoudre les problèmes éventuels. Parallèlement, la liaison directe de NetBasis International avec nos fabricants partenaires garantit une qualité de support constante et élevée dans toute la région DACH.";
const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

const benefits = [
  "Réponse aux questions générales concernant l'application et l'utilisation des produits et solutions",
  "Assistance compétente avec et pour des informations opérationnelles spécifiques",
  "Mise à disposition fiable de manuels d'installation et de configuration",
  "Aide professionnelle à l'installation et à la configuration sur site",
  "Support local rapide par téléphone, e-mail et Internet",
  "Analyse précise des erreurs et dépannage via une maintenance à distance moderne",
  "Identification et vérification des erreurs éventuelles et de leurs causes sous-jacentes",
  "Élaboration de propositions concrètes de résolution pour les erreurs et dysfonctionnements identifiés",
  "Maintenance professionnelle conformément aux accords correspondants et aux niveaux de service (Service Level Agreements)",
  "Support structuré multi-tier et multi-level pour les systèmes TIC complexes",
];

export default function SupportTechniqueFrPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Support Technique | NetBasis International"
        description="Assistance locale fiable de niveaux 1 et 2 pour garantir une satisfaction client élevée dans la région DACH."
        ogUrl="https://net-basis.net/fr/services/developpement-commercial/support-technique"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-center pt-[10%] md:pt-[8%] lg:pt-[10%] pointer-events-none">
                <p
                  className="text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-center leading-[1.15] md:leading-[1.5] animate-[technischerSupportTextSlide_12s_ease-in-out_infinite]"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  <span className="block md:inline">{heroClaimLine1}</span>{" "}
                  <span className="block md:inline">{heroClaimLine2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <h1 className="font-semibold text-foreground-950 leading-relaxed text-sm md:text-base mb-4">
              {h2Intro}
            </h1>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
              <p>{p1Text}</p>
            </div>

            {/* Benefits heading with italic word */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>

            {/* Benefits with checkmarks */}
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}